import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { DataTypeComponent } from '../../../data-type-component';
import { MyErrorStateMatcher } from '../../../../../../common/field-validation/my-error-state-matcher';
import { EntityGroupDetailsService } from '../../../../../views/entity-group/entity-group-details/entity-group-details.service';

@Component({
  selector: 'app-nested-panel-form-field',
  templateUrl: './nested-panel-form-field.component.html',
  styleUrls: ['./nested-panel-form-field.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: false,
})
export class NestedPanelFormFieldComponent extends DataTypeComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() withBorder = true;

  @Input() data: any;

  @Input() editMode: boolean;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  @Input() fields: FieldConfigDTO[];

  @Input() canAdd: boolean;

  @Output() valueChange = new EventEmitter<any>();

  @Output() dataChange = new EventEmitter<any>();

  @Output() formGroupChange = new EventEmitter<UntypedFormGroup>();

  public formGroupSubset: UntypedFormGroup;

  public editFields: FieldConfigDTO[];

  public viewFields: FieldConfigDTO[];

  public formFields: FieldConfigDTO[];

  public loading = true;

  public initialized = false;

  public expandable = false;

  public expanded: boolean = false;

  constructor(
    private entityGroupService: EntityGroupDetailsService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (this.initialized && !changes.editMode) {
      this.initialize();
    }
  }

  ngOnInit() {
    this.initialize();
    this.assignInternalFormToParent();
    this.initialized = true;
    const { data } = this;
    this.expandable = this.fieldConfig && eval(this.fieldConfig.expandablePanel);
  }

  private assignInternalFormToParent() {
    let firstChange = true;
    this.formGroupSubset.valueChanges.subscribe((v) => {
      if (firstChange) {
        this.formGroup?.setControl(this.fieldConfig.name, this.formGroupSubset);
      }
      firstChange = false;
    });
  }

  public initialize() {
    this.createFormGroupsIfNeededV2(this.data);
    this.formGroup?.setControl(this.fieldConfig.name, this.formGroupSubset);

    this.editFields = this.fieldConfig.innerFields.filter((f) => !f.editHide);
    this.viewFields = this.fieldConfig.innerFields.filter((f) => !f.viewHide);
    this.formFields = this.getFields();
    this.loading = false;
    this.logFields();
  }

  private logFields() {
    let logMessage: string = '';
    this.formFields.forEach((fld) => {
      logMessage += ` ${fld.label}`;
    });
  }

  private createFormGroupsIfNeededV2(data: any) {
    const formGroupBuilder = {};
    this.fieldConfig.innerFields.forEach((f) => {
      const formControl = this.getFormControlForField(f, data);
      formGroupBuilder[f.name] = formControl;
    });
    this.formGroupSubset = new UntypedFormGroup(formGroupBuilder);
  }

  private getFormControlForField(f: FieldConfigDTO, data: any) {
    const disabled = f.editReadOnly;
    const value = data ? data[f.name] : undefined;

    const validators = MyErrorStateMatcher.convertToAngularValidators([f]);
    const formControl = new UntypedFormControl(
      {
        value,
        disabled,
      },
      validators
    );
    return formControl;
  }

  getFields(): FieldConfigDTO[] {
    return this.editMode
      ? this.editFields
      : this.viewFields.filter((f) => {
          const value = this.formGroupSubset.getRawValue()[f.name];
          if (!f.ignoreIfNotPresent) {
            return true;
          }
          return !!value;
        });
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  expand() {
    this.expanded = !this.expanded;
    this.entityGroupService.isotopeLayout.next();
  }
}
